import {RemoveScrollBar} from 'react-remove-scroll-bar'

export const LockScroll = RemoveScrollBar
